export default __webpack_public_path__ + "static/media/higher_brand_marque.7b849844.svg";